<div class="custom-toolbar">
  <div class="custom-button-container">
    <yo-button
      (onClick)="refreshAlertes()"
      tooltip="Actualiser les alertes"
      [theme]="ButtonThemeEnum.SECONDARY_INNER"
      iconClass="fas fa-arrows-rotate">
    </yo-button>
    <yo-button
      (onClick)="convertToOrder()"
      [disabled]="selectedStockAlerteList.length == 0"
      tooltip="Générer les commandes fournisseurs"
      [theme]="ButtonThemeEnum.SECONDARY_INNER"
      iconClass="fas fa-play">
    </yo-button>
  </div>

  <dx-text-box class="custom-toolbar-element"
               valueChangeEvent="keyup"
               (onValueChanged)="announceGlobalFilterSearch($event)"
               placeholder="Recherche...">
  </dx-text-box>

  <dx-lookup
    class="custom-toolbar-element"
    [searchEnabled]="true"
    [items]="siteStockMiniList"
    valueExpr="idSite"
    [(value)]="selectedSite"
    itemTemplate="listItem"
    displayExpr="libelleSite"
    (onValueChanged)="initStockAlertList()"
    width="250px">
    <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
    <div *dxTemplate="let site of 'listItem'">
      <span *ngIf="site?.nbAlerte > 0" class="mr-1 badge badge-danger">{{ site?.nbAlerte }}</span>
      <span>{{ site?.libelleSite }}</span>
    </div>
  </dx-lookup>
</div>

<dx-data-grid
  [dataSource]="stockAlerteList"
  keyExpr="id"
  id="stock-min-dx-grid"
  height="100%"
  [hoverStateEnabled]="true"
  [allowColumnResizing]="true"
  [showRowLines]="true"
  [showBorders]="true"
  columnResizingMode="widget"
  [(selectedRowKeys)]="selectedStockAlerteList"
  [allowColumnReordering]="true"
  noDataText="Aucun produit en alerte"
  #grid>

  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-header-filter [visible]="true"></dxo-header-filter>
  <dxo-selection
    selectAllMode="allPages"
    showCheckBoxesMode="always"
    mode="multiple">
  </dxo-selection>

  <dxi-column dataField="id" caption="Actions"
              [width]="65"
              alignment="left"
              [allowFiltering]="false"
              [allowGrouping]="false"
              cellTemplate="actionsCellTemplate">
  </dxi-column>
  <dxi-column dataField="openOrder" caption="Commandes en cours"
              alignment="left"
              [allowFiltering]="false"
              [allowGrouping]="false"
              cellTemplate="orderCellTemplate">
  </dxi-column>
  <dxi-column dataField="produitDeclinaisonLibelle" caption="Denrée"
              alignment="left"
              [allowFiltering]="true"
              [filterOperations]="['contains']"
              [allowGrouping]="true">>
  </dxi-column>
  <dxi-column dataField="produitDeclinaisonCode" caption="Code"
              alignment="left"
              [filterOperations]="['contains']"
              [allowFiltering]="true"
              [allowGrouping]="true">>
  </dxi-column>
  <dxi-column dataField="quantite" caption="Quantité à prevoir"
              alignment="left"
              [filterOperations]="['contains']"
              [allowFiltering]="true"
              [allowGrouping]="true">
  </dxi-column>
  <dxi-column dataField="quantiteAlerte" caption="Quantité stock minimum"
              alignment="left"
              [filterOperations]="['contains']"
              [allowFiltering]="true"
              [allowGrouping]="true">>
  </dxi-column>
  <dxi-column dataField="uniteTechniqueLibelleAbreviation" caption="Unité"
              alignment="left"
              [filterOperations]="['contains']"
              [allowFiltering]="true"
              [allowGrouping]="true">>
  </dxi-column>
  <dxi-column dataField="zoneDeStockageLibelle" caption="Zone de stockage"
              alignment="left"
              [filterOperations]="['contains']"
              [allowFiltering]="true"
              [allowGrouping]="true">>
  </dxi-column>


      <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
        <yo-button size="small"
                    [theme]="ButtonThemeEnum.DELETE_INNER"
          (onClick)="deleteStockAlerte([cell.row.data.id])"
          iconClass="fas fa-trash"
          tooltip="Retrait de l'alerte">
        </yo-button>
      </div>

  <div *dxTemplate="let cell of 'orderCellTemplate'">
    <ng-container *ngIf="cell.row.data.openOrder">
      <i (mouseenter)="changeSelectedAlerte(cell.row.data)" class="fas fas fa-cubes fa-xl" id="order-{{cell.row.data.id}}"></i>
      <dx-tooltip
        target="#order-{{cell.row.data.id}}"
        showEvent="mouseenter"
        hideEvent="mouseleave">
        <div *dxTemplate="let _ = data; of: 'content'">
          <div *ngIf="orders?.length > 0">
            <div *ngFor="let order of orders">
              <span> Commande {{ order.numeroCommande }} - Quantité commandée {{ order.quantiteUC }} {{ order.uniteCommande }}</span>
              <span *ngIf="order.quantiteUT != order.quantiteUC"> ( = {{ order.quantiteUT }} {{ order.uniteTechnique }}) </span>
              <span> - Date livraison {{ order.dateLivraison | date: 'dd/MM/yyyy' }}</span>
            </div>
          </div>
        </div>
      </dx-tooltip>
    </ng-container>
  </div>
</dx-data-grid>

<yo-create-proposition-denree></yo-create-proposition-denree>
